import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import api from "../../utils/Api";
import { Eye, EyeOff } from "lucide-react";

export default function EditarPerfil() {
  const { token, user } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    dni: "", nombre: "", apellidos: "", email_usuario: "",
    telefono_usuario: "", password: "", password_confirmation: "",
  });
  const [loading, setLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  useEffect(() => {
    const fetchUser = async () => {
      if (!token || !user) return;
      try {
        const { data } = await api.get(`/usuarios/${user.id}`, { headers: { Authorization: `Bearer ${token}` } });
        setFormData({
          dni: data.dni || "", nombre: data.nombre || "", apellidos: data.apellidos || "",
          email_usuario: data.email || "", telefono_usuario: data.telefono || "",
          password: "", password_confirmation: "",
        });
        setLoading(false);
      } catch {
        setMessage({ type: "danger", text: "No se pudo cargar el perfil" });
        setLoading(false);
      }
    };
    fetchUser();
  }, [token, user]);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: "", text: "" });
    try {
      const payload = { ...formData };
      if (!payload.password) { delete payload.password; delete payload.password_confirmation; }
      await api.put(`/usuarios/${user.id}`, payload, { headers: { Authorization: `Bearer ${token}` } });
      setMessage({ type: "success", text: "Perfil actualizado correctamente" });
      setFormData({ ...formData, password: "", password_confirmation: "" });
    } catch (error) {
      const errors = error.errors ?? error.response?.data?.errors;
      const firstValidation = errors ? Object.values(errors)[0]?.[0] : null;
      setMessage({ type: "danger", text: firstValidation || error.message || error.response?.data?.message || "Error al actualizar perfil" });
    }
  };

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 200, color: "var(--clr-muted)", fontSize: 14 }}>
      Cargando perfil…
    </div>
  );

  return (
    <div>
      <h1 className="tn-page-title">Editar perfil</h1>
      <p className="tn-page-sub">Actualiza tus datos personales y contraseña</p>

      <div className="tn-card" style={{ maxWidth: 680, padding: 28 }}>
        {message.text && (
          <div className={`tn-alert tn-alert--${message.type}`} style={{ marginBottom: 20 }}>{message.text}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))", gap: 16, marginBottom: 20 }}>
            <div>
              <label className="tn-label">DNI</label>
              <input
                className="tn-input"
                type="text"
                name="dni"
                value={formData.dni}
                readOnly
                disabled
                title="El DNI solo puede modificarlo un administrador"
                style={{ background: "var(--clr-surface)", cursor: "not-allowed" }}
              />
            </div>
            <div>
              <label className="tn-label">Nombre</label>
              <input className="tn-input" type="text" name="nombre" value={formData.nombre} onChange={handleChange} required />
            </div>
            <div>
              <label className="tn-label">Apellidos</label>
              <input className="tn-input" type="text" name="apellidos" value={formData.apellidos} onChange={handleChange} required />
            </div>
            <div>
              <label className="tn-label">Email</label>
              <input className="tn-input" type="email" name="email_usuario" value={formData.email_usuario} onChange={handleChange} required />
            </div>
            <div>
              <label className="tn-label">Teléfono</label>
              <input className="tn-input" type="text" name="telefono_usuario" value={formData.telefono_usuario} onChange={handleChange} />
            </div>
          </div>

          <div style={{ borderTop: "1px solid var(--clr-border)", paddingTop: 20, marginBottom: 24 }}>
            <p style={{ fontSize: 13, color: "var(--clr-muted)", marginBottom: 14 }}>Cambiar contraseña — deja en blanco para mantener la actual</p>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))", gap: 16 }}>
              <div>
                <label className="tn-label">Nueva contraseña</label>
                <div style={{ position: "relative" }}>
                  <input className="tn-input" type={showPassword ? "text" : "password"} name="password" value={formData.password} onChange={handleChange} style={{ paddingRight: 42 }} />
                  <button type="button" onClick={() => setShowPassword(!showPassword)}
                    style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "var(--clr-muted)", display: "flex" }}>
                    {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                </div>
              </div>
              <div>
                <label className="tn-label">Confirmar contraseña</label>
                <div style={{ position: "relative" }}>
                  <input className="tn-input" type={showPasswordConfirm ? "text" : "password"} name="password_confirmation" value={formData.password_confirmation} onChange={handleChange} style={{ paddingRight: 42 }} />
                  <button type="button" onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                    style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "var(--clr-muted)", display: "flex" }}>
                    {showPasswordConfirm ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <button type="submit" className="tn-btn tn-btn--primary tn-btn--lg" style={{ width: "100%", justifyContent: "center" }}>
            Guardar cambios
          </button>
        </form>
      </div>
    </div>
  );
}
